import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from '../../../api.service';
// import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import Swal from 'sweetalert2';
import { Router, RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
  selector: 'app-reallocation',
  templateUrl: './reallocation.component.html',
  styleUrls: ['./reallocation.component.css']
})
export class ReallocationComponent implements OnInit {

  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  AllocationcolumnDefs = [
    {headerName: 'CUSTOMER ID', field: 'customer_id', width: 250, checkboxSelection: true,headerCheckboxSelection: true,sortable: true, filter: true},
    {headerName: 'ACCOUNT NUMBER', field: 'acc_no', resizable: true, sortable: true, filter: true},
    {headerName: 'PASSPORT NUMBER', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {headerName: 'AGREEMENT NUMBER', field: 'agreement_id', resizable: true, sortable: true, filter: true},
    {headerName: 'CIF NUMBER', field: 'cif', resizable: true, sortable: true, filter: true},
    {headerName: 'UNIQUE ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'TOTAL OUTSTANDING', field: 'total_out_standing', resizable: true, sortable: true, filter: 'agNumberColumnFilter'},
  ];
  displayPosition: boolean;
  rows = [];
  searchQR: any;
  value1: any;
  rangeValues: number[] = [0,100];

  Finals_excel : any;

  Bank_list_gets : any;
  product_list_gets  : any;
  portfolio_list_gets  : any;


  booleans : any;

  User_details1 : any;

  timeLeft: number = 60;
  interval;

  loading: Boolean = true;


  Excel_Datas :  any;
  saved_Fields : any = [];
  NAT_List =  [{name:"Ethiopia",status:false},{name:"India",status:false},{name:"Pakistan",status:false}];

  AGENT_List =  [{name:"AGENT 1",status:false},{name:"AGENT 2",status:false},{name:"AGENT 3",status:false}];

  user_list_details : any;
  Company_details : any;
  Designation_details2 : any;
  report_to : any;
  report_to_id : any;
  company_name : any;
  report_to_design : any;

  Designation_details1 : any;
  MyuploadList = [];
  tempDefs = [];
  columnDefs = [];
  dataLoaded: boolean;
  selectedData = [];
  login_Details: any;
  bankName: any;
  bankame: any;
  portfolio: any;
  product: any;

  bucket_details : any;

  bucket_detail : any;

  final_data : any;
  allSelected: boolean;
  userFilter: any = { allocations_status: '' };
  NewCount: number;
  ExsistingCount: number;

  saved_Fields_Existing : any;
  saved_Fields_New : any;

  exisiting_count : number = 0;
  new_count : number = 0; 





  Designation_details_one : any;
  report_to_design_one : any;
  User_details2 : any;
  report_to_one : any;
  report_to_id_one : any;




  Bank_list : any = [];
  product_list :  any = [];
  portfolio_list :  any = [];
  original_product_list : any;
  original_bank_list : any;
  original_portfolio_list : any;

  bank_id : any ;
  portfolio_id : any;
  product_id : any;
  // Bank_list_gets : any;
  // portfolio_list_gets : any;
  




  constructor(
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private _api: ApiService,
    // private router: Router
  ) { }



  ngOnInit(): void {
    this.booleans = false;
    this.Bank_list_get();
    this.product_list_get();
    this.portfolio_list_get();
    this.fetch_user();
  }


  Bank_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(
      (response: any) => {
        this.original_bank_list = response.Data;
        this.Bank_list = [];
       var hash = response.Data.reduce((p,c) => (p[c.bank_name] ? p[c.bank_name].push(c) : p[c.bank_name] = [c],p) ,{});
       var  newData = Object.keys(hash).map(k => ({color: k, car: hash[k]}));
        for(let a = 0 ; a < newData.length; a ++){
          let x =  { 'y': newData[a].color}
          this.Bank_list.push(x);
        }
        // this.rows = response.Data.reverse();
        // console.log(this.rows);
      }
    );



  }

  product_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.product_type_list(a).subscribe(
      (response: any) => {
        this.product_list = response.Data;
        this.original_product_list = response.Data;
      }
    );
  }


  portfolio_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.portfolio_type_list(a).subscribe(
      (response: any) => {
        this.original_portfolio_list = response.Data;
        let list = response.Data;
        for (let i = 0; i < list.length; i++) {
          let obj = { "y": list[i].portfolio_type};
          this.portfolio_list.push(obj);
        }
        this.booleans = true;
      }
    );
  }




  fetch_allocation_detail(){
    for(let a = 0 ; a < this.original_bank_list.length ; a ++){
      if(this.original_bank_list[a].bank_name == this.Bank_list_gets.y){
        this.bank_id = this.original_bank_list[a]._id;
      }
      if(a == this.original_bank_list.length - 1){
      for(let b = 0 ; b < this.original_portfolio_list.length ; b ++){
        if(this.original_portfolio_list[b].portfolio_type == this.portfolio_list_gets.y){
          this.portfolio_id = this.original_portfolio_list[b]._id;
        }
      if(b == this.original_portfolio_list.length - 1){
      this.product_id = this.product_list_gets;
      this.fetch_field_list();
          }
        }
      }
    }
  }



    fetch_field_list(){
   
    var a = {
      assigned_to : this.report_to_id,
      bank_id : this.bank_id,
      product_id : this.product_id,
      porfolio_id : this.portfolio_id,
    }

    console.log(a);
    this._api.allocation_details_getassignedto(a).subscribe(
    (response: any) => {
      this.loading = true;
      // this.Finals_excel = response.Data;
      // this.getUserbyStatus(response.Data);
      this.saved_Fields = response.Data;
      this.saved_Fields.forEach((item, i) => {
        item.select_status = false;
      });
      console.log(this.saved_Fields);
    });

    this.rows = [{ type: "Dog", name: "dog1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    ]



  }



  fetch_user(){
    this._api.user_details_list().subscribe(
      (response: any) => {
        this.user_list_details = response.Data;
        this.Company_details = [];
       var hash = response.Data.reduce((p,c) => (p[c.bankname] ? p[c.bankname].push(c) : p[c.bankname] = [c],p) ,{});
       var  newData = Object.keys(hash).map(k => ({color: k, car: hash[k]}));
        for(let a = 0 ; a < newData.length; a ++){
          let x =  { 'y': newData[a].color}
          this.Company_details.push(x);
        }
      }
    );

  this._api.designation_type_list().subscribe(
  (response: any) => {
    this.Designation_details1 = [];
    this.Designation_details2 = [];
    this.Designation_details_one = [];
    for(let a = 0 ; a < response.Data.length; a ++){
      let x =  { 'y': response.Data[a].designation_type}
      let y =  { 'x': response.Data[a].designation_type}
      this.Designation_details1.push(x);
      this.Designation_details2.push(y);
      this.Designation_details_one.push(x);
    }
    this.Designation_details1 = this.Designation_details1.reverse();
    this.Designation_details2 = this.Designation_details2.reverse();
    this.Designation_details_one =  this.Designation_details_one.reverse();
  }
);
}


 /////fetch user one/////////


  fetchuser_1(){

    let req = {
      "bankname" : "",
      "designation" : this.report_to_design.y
    }
    this._api.user_details_list_by_com(req).subscribe(
      (response: any) => {
        if(response.Data.length == 0){
         alert("There is no user with this designations");
        }else {
          this.User_details1 = [];
          this.User_details2 = [];
          for(let a = 0 ; a < response.Data.length; a ++){
            let x =  { 'y': response.Data[a].email_id}
            this.User_details1.push(x);
            this.User_details2.push(x);
          }
          this.User_details1 = this.User_details1.reverse();
          this.User_details2 = this.User_details2.reverse();
        }
      }
    );
  }


  Report_fetch(){
    for(let a = 0 ; a < this.user_list_details.length; a ++){
      if(this.user_list_details[a].email_id == this.report_to.y){
         this.report_to_id = this.user_list_details[a]._id;
      }
    }
  }

  ////////fetch user two  //////


  fetchuser_2(){

    let req = {
      "bankname" : "",
      "designation" : this.report_to_design_one.y
    }
    this._api.user_details_list_by_com(req).subscribe(
      (response: any) => {
        if(response.Data.length == 0){
         alert("There is no user with this designations");
        }else {
          this.User_details2 = [];
          for(let a = 0 ; a < response.Data.length; a ++){
            let x =  { 'y': response.Data[a].email_id}
            this.User_details2.push(x);
          }
          this.User_details2 = this.User_details2.reverse();
        }
      }
    );
  }



  Report_fetch_1(){
    for(let a = 0 ; a < this.user_list_details.length; a ++){
      if(this.user_list_details[a].email_id == this.report_to_one.y){
         this.report_to_id_one = this.user_list_details[a]._id;
      }
    }
  }

  saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  toggleEditable(status: any, index: any){
   this.saved_Fields[index].select_status = status;
  }


  submit_allocation(){
      this.final_data = [];
      const selectedNodes = this.agGrid.api.getSelectedNodes();
      const selectedData = selectedNodes.map(node => node.data );
      if (selectedData.length > 0) {
        for (let i = 0; i < selectedData.length; i++) {
          this.final_data.push(selectedData[i]);
        }
        this.start_allocation();
      } else {
        alert("Please Select atleast one Customer");
      }
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  fetchuser_3(){
    console.log();
    for(let a = 0 ; a < this.original_bank_list.length ; a ++){
     if(this.original_bank_list[a].bank_name == this.Bank_list_gets.y){
       this.bank_id = this.original_bank_list[a]._id;
       console.log("Bank Id Found");
     }
   }
    console.log("Client Id Detail",this.getFromLocal("Client_ID"))
     let a = {
       client_id : this.getFromLocal("Client_ID"),
       bank_id : this.bank_id
     }
     console.log(a);
     this._api.portfolio_type_list_bank_id(a).subscribe(
       (response: any) => {
         console.log(response.Data);
         this.portfolio_list = [];
        //  this.portfolio_list = response.Data;
         let list = response.Data;
         for (let i = 0; i < list.length; i++) {
           let obj = { "y": list[i].portfolio_type};
           this.portfolio_list.push(obj);
         }
         this.booleans = true;
       }
     );
   }


  start_allocation(){
    this.loading = false;
    if(this.report_to_id_one == undefined){
      alert('Please Select the user');
    } else {
      this.timeLeft = this.final_data.length;
      this.interval = setInterval(() => {
        if(this.timeLeft > 0) {
          this.timeLeft--;
      let c = {
      _id : this.final_data[this.timeLeft]._id,
      assigned_by : this.getFromLocal("User_ID"),
      assigned_to : this.report_to_id_one,  
      date_of_allocations : ""+new Date()   
          }
            this._api.allocation_details_reallocation2(c).subscribe(
              (response: any) => {
              }
            );
        } else {
          this.timeLeft = 0;
          // alert("Allocated succesfully");
          this.loading = true;
          this.fetch_allocation_detail();
          this.ngOnInit();
          this.pauseTimer();
        }
      },2000);
    }
  }


  showPositionDialog() {
    this.displayPosition = true;
  }


  getCustomer(page,data){
    
    data.customer_details = JSON.parse(data.customer_details)

  
    var convDatav = data.customer_details;
    var jsonObject = convDatav[0];
    var keyCount  = Object.keys(jsonObject).length;
    
    this.router.navigateByUrl(page);
    let dataList = [];
    for (let i = 0; i < convDatav.length; i++) {
          for (let i = 0; i < keyCount; i++) {
            var key = Object.keys(jsonObject)[i];
            var value = jsonObject[key];
            dataList.push({column:key,row:value});
          }
        }

      this.storage.set("_storedRecord",{dataList,"keyvalue":data});

  }

  getallSelected(event){
    if (event.target.checked) {
      this.allSelected =  true;
      for (let i = 0; i < this.saved_Fields.length; i++) {
        this.saved_Fields[i].select_status = true;
      }
      alert("All Records Selected");
    } else {
      this.allSelected =  false;
      for (let i = 0; i < this.saved_Fields.length; i++) {
        this.saved_Fields[i].select_status = false;
      }
      alert("All Records Deselected")
    }
  }


  getNaT(event,item){
    this.userFilter.NATION_NAME = item.name;
  }


  getAgenT(event,item){
    // this.userFilter.NATION_NAME = item.name;
  }


  getUserbyStatus(data){
    this.NewCount = 0;
    this.ExsistingCount = 0;
    for (let i = 0; i < data.length; i++) {
      const custData = {
        passport_no: data[i].passport_no,
        acc_no:data[i].acc_no
      }
      
      this._api.getAccountStatus(custData).subscribe(data=>{
        if (data['Status'] == 'Success') {
          if (data['userType'] =="New") {
            this.NewCount = this.NewCount + 1;
          } else {
            this.ExsistingCount = this.ExsistingCount + 1;
          }
        } else {
          
        }
      });      
    }
  }


  

  showPositionDialog_hide() {
    this.displayPosition = false;
    this.final_assinged_to();
  }


  final_assinged_to(){
    if(""+this.report_to_id_one == ""+this.report_to_id){
      alert("you have selected same person");
    }else{
      console.log(this.report_to_id);
      console.log(this.report_to_id_one);
      this.submit_allocation();
    }

  }


}
